import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolder = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		clipRule: "evenodd",
		d: "M3 20H21V6H11L9 4H5L3 6V20ZM5 8H12H19V18H5V8Z"
	})
});
export default SvgFolder;
